import { getLocalStorage } from '@/services/localSessionService';
import { errorLog } from '../../services/consoleLog';
import Loader from '@/components/common/Loader';

export const myFallback = (
  <div className="fixed top-0 left-0 bottom-0 right-0 bg-black-500 z-[99999] bg-[#4755696e] backdrop-blur-sm">
    <div className="flex items-center justify-center h-screen w-screen">
      <Loader>
        <div className='text-black'>Wait, We are loading page...</div>
      </Loader>
    </div>
  </div>
);
export const pageSize = () => {
  try {
    if (getLocalStorage('pageSize')) {
      return getLocalStorage('pageSize');
    }
    return '15';
  } catch (err) {
    errorLog('Error', err);
  }
};

export const Languages = {
  flightApiError: 'Oops! There are some issue in Flight Api. Try after sometime.',
  serverError: 'Oops! Some error in backend server. Please, try after sometime.',
  noUserExist: 'Oops! No user credential found with provided information',
  wrongPassword: 'Oops! Your password is not valid, please try again or follow forgot password',
  pedAdded: 'Pet added successfully',
};

/**
 * Convert BASE64 to BLOB
 */
export function convertBase64ToBlob(base64Image: string) {
  // Split into two parts
  const parts = base64Image.split(';base64,');
  // Hold the content type
  const imageType = parts[0].split(':')[1];
  // Decode Base64 string
  const decodedData = window.atob(parts[1]);
  // Create UNIT8ARRAY of size same as row data length
  const uInt8Array = new Uint8Array(decodedData.length);
  // Insert all character code into uInt8Array
  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }
  // Return BLOB image after conversion
  return new Blob([uInt8Array], { type: imageType });
}

export function isEmpty(value: any) {
  return value === null || value === undefined || (typeof value === 'string' && value.trim().length === 0);
}

export const statusDropDown = [
  { label: 'No', value: 'No' },
  { label: 'Yes', value: 'Yes' },
];
